export const dashboardTranslations = {
  fr: {
    title: "Tableau de bord",
    welcome: "Bienvenue",
    loading: "Chargement...",
    header: {
      trialExpired: "Essai expiré",
      trialRemaining: "{{days}} jours restants",
      manageSubscription: "Gérer l'abonnement"
    },
    aiChat: {
      title: "Assistant IA Médical",
      subtitle: "Votre compagnon d'apprentissage personnalisé",
      description: "Posez vos questions médicales, créez des flashcards, générez des fiches de révision...",
      newConversation: "Nouvelle conversation",
      continueConversation: "Continuer la conversation",
      revisionExpress: "Révision Express (5 min)",
      chipDiagnosis: "Aide au diagnostic",
      chipRevise: "Réviser un cours",
      chipExplain: "Expliquer un concept",
      ariaLabel: "Ouvrir l'assistant IA médical",
      suggestionsLabel: "Suggestions rapides"
    },
    skipToContent: "Aller au contenu",
    streak: {
      currentStreak: "Série actuelle",
      days: "jours",
      record: "Record : {{count}}",
      loading: "Chargement...",
      message0: "Commencez votre série dès aujourd'hui !",
      message3: "Continuez comme ça !",
      message7: "Belle série ! 🔥",
      message30: "Incroyable ! Vous êtes sur une lancée !",
      messageLegend: "LÉGENDE ! Série exceptionnelle ! 🏆",
      shareText: "🔥 {{count}} jours de suite sur Sclépios IA ! Teste tes connaissances médicales 👇",
      share: "Partager"
    },
    dailyGoal: {
      title: "Objectif du jour",
      flashcards: "Réviser des flashcards",
      quiz: "Compléter le quiz du jour",
      chat: "Discuter avec l'assistant IA",
      completed: "{{count}}/{{total}} complétés",
      goalReached: "🎉 Objectif atteint !"
    },
    trial: {
      label: "Essai : ",
      daysRemaining: "{{count}}j restant",
      daysRemaining_plural: "{{count}}j restants",
      actions: "{{used}}/{{total}} actions",
      seePlans: "Voir les forfaits"
    },
    referral: {
      title: "Invitez un collègue",
      subtitle: "+7j Premium pour vous, +3j pour votre filleul",
      godchildren: "{{count}} filleul",
      godchildren_plural: "{{count}} filleuls",
      nextMilestone: "Prochain palier :",
      shareLink: "Partager le lien",
      shareText: "🩺 Rejoins Sclépios IA, l'assistant médical intelligent ! Utilise mon code {{code}} pour obtenir 3 jours Premium gratuits 🎁",
      milestoneAmbassador: "Ambassadeur",
      milestoneRecruiter: "Recruteur",
      milestoneLegend: "Légende",
      rewardAmbassador: "Badge Ambassadeur",
      rewardRecruiter: "Badge Recruteur",
      rewardLegend: "1 mois Premium offert"
    },
    explore: {
      title: "Explorer toutes les fonctionnalités",
      learning: "Apprentissage",
      clinicalTools: "Outils cliniques",
      community: "Communauté",
      revisionSheets: "Fiches de révision",
      study: "Étude",
      courses: "Cours",
      clinicalCases: "Cas cliniques",
      calculators: "Calculateurs",
      checklists: "Checklists",
      medications: "Médicaments",
      coding: "Codage",
      guidelines: "Guidelines",
      forum: "Forum",
      scores: "Scores"
    },
    stats: {
      title: "Vos statistiques",
      flashcards: "Flashcards",
      sessions: "Sessions",
      totalTime: "Temps total",
      accuracy: "Précision",
      aiConversations: "Conversations IA",
      revisionSheets: "Fiches de révision",
      qcmCompleted: "QCM terminés",
      communityPosts: "Publications"
    },
    quickActions: {
      title: "Actions rapides",
      description: "Accédez rapidement à vos outils d'apprentissage préférés",
      startStudy: "Commencer une étude",
      createFlashcard: "Créer des flashcards",
      reviewCards: "Réviser les cartes",
      newChat: "Nouveau chat",
      newChatDesc: "Discutez avec l'IA médicale pour obtenir des réponses à vos questions",
      flashcards: "Flashcards",
      flashcardsDesc: "Créez et étudiez avec des cartes de révision intelligentes",
      revisionSheets: "Fiches de révision",
      revisionSheetsDesc: "Consultez vos fiches de révision générées par l'IA",
      study: "Étudier",
      studyDesc: "Entraînez-vous avec des QCM et cas cliniques adaptatifs",
      scores: "Scores",
      scoresDesc: "Calculez des scores médicaux et indices cliniques",
      community: "Communauté",
      communityDesc: "Partagez et discutez avec la communauté médicale",
      calculator: "Calculatrice",
      calculatorDesc: "Outils de calcul médical et dosages",
      checklists: "Checklists",
      checklistsDesc: "Listes de vérification pour procédures médicales",
      medications: "Médicaments",
      medicationsDesc: "Base de données des médicaments et interactions",
      coding: "Codage",
      codingDesc: "Codes CIM-10 et outils de codage médical",
      rss: "Actualités RSS",
      rssDesc: "Suivez les dernières actualités médicales"
    },
    recentActivity: {
      title: "Activité récente",
      description: "Votre progression et activités récentes",
      noActivity: "Aucune activité récente",
      active: "Actif",
      available: "Disponible",
      progress: "En cours",
      participate: "Participer",
      new: "Nouveau",
      create: "Créer",
      conversations: "{{count}} conversation{{s}}",
      flashcards: "{{count}} flashcard{{s}}",
      revisionSheets: "{{count}} fiche{{s}} de révision",
      qcmCompleted: "{{count}} QCM terminé{{s}}",
      communityPosts: "{{count}} publication{{s}}",
      firstChat: "Commencez votre première conversation",
      firstFlashcards: "Créez vos premières flashcards",
      firstRevisionSheet: "Générez votre première fiche"
    },
    badges: {
      title: "Badges",
      noBadges: "Aucun badge gagné pour le moment. Continuez à faire des quiz pour débloquer vos premiers badges !",
      badgeUnlocked: "Badge débloqué"
    },
    milestones: {
      title: 'Vos Prochains Objectifs',
      subtitle: 'Continuez à progresser pour débloquer des récompenses exclusives',
      allCompleted: 'Félicitations ! Vous avez atteint tous les objectifs disponibles',
      unlocked: 'Débloqué',
      progress: 'Progression',
      streak7Title: 'Série de 7 jours',
      streak7Desc: "Connectez-vous 7 jours d'affilée",
      streak7Reward: '100 XP + Badge Dévoué',
      streak30Title: 'Série de 30 jours',
      streak30Desc: 'Un mois de discipline quotidienne',
      streak30Reward: '500 XP + 1 semaine Premium gratuite',
      flashcards100Title: 'Maître des Flashcards',
      flashcards100Desc: 'Créez 100 flashcards',
      flashcards100Reward: 'Badge Flashcard Master',
      quiz50Title: 'Expert Quiz',
      quiz50Desc: 'Complétez 50 quiz quotidiens',
      quiz50Reward: 'Badge Quiz Champion + 300 XP',
      chat100Title: 'Conversationniste',
      chat100Desc: "Ayez 100 conversations avec l'IA",
      chat100Reward: 'Badge AI Expert + 400 XP',
    }
  },
  en: {
    title: "Dashboard",
    welcome: "Welcome",
    loading: "Loading...",
    header: {
      trialExpired: "Trial expired",
      trialRemaining: "{{days}} days remaining",
      manageSubscription: "Manage subscription"
    },
    aiChat: {
      title: "Medical AI Assistant",
      subtitle: "Your personalized learning companion",
      description: "Ask your medical questions, create flashcards, generate revision sheets...",
      newConversation: "New conversation",
      continueConversation: "Continue conversation",
      revisionExpress: "Express Review (5 min)",
      chipDiagnosis: "Diagnosis help",
      chipRevise: "Review a topic",
      chipExplain: "Explain a concept",
      ariaLabel: "Open the medical AI assistant"
    },
    streak: {
      currentStreak: "Current streak",
      days: "days",
      record: "Record: {{count}}",
      loading: "Loading...",
      message0: "Start your streak today!",
      message3: "Keep it up!",
      message7: "Great streak! 🔥",
      message30: "Incredible! You're on a roll!",
      messageLegend: "LEGEND! Exceptional streak! 🏆",
      shareText: "🔥 {{count}} days in a row on Sclépios IA! Test your medical knowledge 👇",
      share: "Share"
    },
    dailyGoal: {
      title: "Daily goal",
      flashcards: "Review flashcards",
      quiz: "Complete the daily quiz",
      chat: "Chat with the AI assistant",
      completed: "{{count}}/{{total}} completed",
      goalReached: "🎉 Goal reached!"
    },
    trial: {
      label: "Trial: ",
      daysRemaining: "{{count}}d remaining",
      daysRemaining_plural: "{{count}}d remaining",
      actions: "{{used}}/{{total}} actions",
      seePlans: "See plans"
    },
    referral: {
      title: "Invite a colleague",
      subtitle: "+7d Premium for you, +3d for your referral",
      godchildren: "{{count}} referral",
      godchildren_plural: "{{count}} referrals",
      nextMilestone: "Next milestone:",
      shareLink: "Share link",
      shareText: "🩺 Join Sclépios IA, the smart medical assistant! Use my code {{code}} for 3 free Premium days 🎁",
      milestoneAmbassador: "Ambassador",
      milestoneRecruiter: "Recruiter",
      milestoneLegend: "Legend",
      rewardAmbassador: "Ambassador Badge",
      rewardRecruiter: "Recruiter Badge",
      rewardLegend: "1 free month of Premium"
    },
    explore: {
      title: "Explore all features",
      learning: "Learning",
      clinicalTools: "Clinical tools",
      community: "Community",
      revisionSheets: "Revision sheets",
      study: "Study",
      courses: "Courses",
      clinicalCases: "Clinical cases",
      calculators: "Calculators",
      checklists: "Checklists",
      medications: "Medications",
      coding: "Coding",
      guidelines: "Guidelines",
      forum: "Forum",
      scores: "Scores"
    },
    stats: {
      title: "Your statistics",
      flashcards: "Flashcards",
      sessions: "Sessions",
      totalTime: "Total time",
      accuracy: "Accuracy",
      aiConversations: "AI Conversations",
      revisionSheets: "Revision sheets",
      qcmCompleted: "MCQ completed",
      communityPosts: "Publications"
    },
    quickActions: {
      title: "Quick actions",
      description: "Quickly access your favorite learning tools",
      startStudy: "Start study",
      createFlashcard: "Create flashcards",
      reviewCards: "Review cards",
      newChat: "New chat",
      newChatDesc: "Chat with medical AI to get answers to your questions",
      flashcards: "Flashcards",
      flashcardsDesc: "Create and study with smart revision cards",
      revisionSheets: "Revision sheets",
      revisionSheetsDesc: "View your AI-generated revision sheets",
      study: "Study",
      studyDesc: "Practice with adaptive MCQ and clinical cases",
      scores: "Scores",
      scoresDesc: "Calculate medical scores and clinical indices",
      community: "Community",
      communityDesc: "Share and discuss with the medical community",
      calculator: "Calculator",
      calculatorDesc: "Medical calculation tools and dosages",
      checklists: "Checklists",
      checklistsDesc: "Verification lists for medical procedures",
      medications: "Medications",
      medicationsDesc: "Drug database and interactions",
      coding: "Coding",
      codingDesc: "ICD-10 codes and medical coding tools",
      rss: "RSS News",
      rssDesc: "Follow the latest medical news"
    },
    recentActivity: {
      title: "Recent activity",
      description: "Your progress and recent activities",
      noActivity: "No recent activity",
      active: "Active",
      available: "Available",
      progress: "In progress",
      participate: "Participate",
      new: "New",
      create: "Create",
      conversations: "{{count}} conversation{{s}}",
      flashcards: "{{count}} flashcard{{s}}",
      revisionSheets: "{{count}} revision sheet{{s}}",
      qcmCompleted: "{{count}} MCQ completed",
      communityPosts: "{{count}} publication{{s}}",
      firstChat: "Start your first conversation",
      firstFlashcards: "Create your first flashcards",
      firstRevisionSheet: "Generate your first sheet"
    },
    badges: {
      title: "Badges",
      noBadges: "No badges earned yet. Keep doing quizzes to unlock your first badges!",
      badgeUnlocked: "Badge unlocked"
    },
    milestones: {
      title: 'Your Next Goals',
      subtitle: 'Keep progressing to unlock exclusive rewards',
      allCompleted: 'Congratulations! You have reached all available goals',
      unlocked: 'Unlocked',
      progress: 'Progress',
      streak7Title: '7-day streak',
      streak7Desc: 'Log in 7 days in a row',
      streak7Reward: '100 XP + Dedicated Badge',
      streak30Title: '30-day streak',
      streak30Desc: 'A month of daily discipline',
      streak30Reward: '500 XP + 1 free Premium week',
      flashcards100Title: 'Flashcard Master',
      flashcards100Desc: 'Create 100 flashcards',
      flashcards100Reward: 'Flashcard Master Badge',
      quiz50Title: 'Quiz Expert',
      quiz50Desc: 'Complete 50 daily quizzes',
      quiz50Reward: 'Quiz Champion Badge + 300 XP',
      chat100Title: 'Conversationalist',
      chat100Desc: 'Have 100 conversations with AI',
      chat100Reward: 'AI Expert Badge + 400 XP',
    }
  },
  es: {
    title: "Panel de control",
    welcome: "Bienvenido",
    loading: "Cargando...",
    header: {
      trialExpired: "Prueba expirada",
      trialRemaining: "{{days}} días restantes",
      manageSubscription: "Gestionar suscripción"
    },
    aiChat: {
      title: "Asistente IA Médico",
      subtitle: "Tu compañero de aprendizaje personalizado",
      description: "Haz tus preguntas médicas, crea tarjetas, genera fichas de revisión...",
      newConversation: "Nueva conversación",
      continueConversation: "Continuar conversación",
      revisionExpress: "Revisión Exprés (5 min)",
      chipDiagnosis: "Ayuda al diagnóstico",
      chipRevise: "Repasar un tema",
      chipExplain: "Explicar un concepto",
      ariaLabel: "Abrir el asistente IA médico"
    },
    streak: {
      currentStreak: "Racha actual",
      days: "días",
      record: "Récord: {{count}}",
      loading: "Cargando...",
      message0: "¡Comienza tu racha hoy!",
      message3: "¡Sigue así!",
      message7: "¡Gran racha! 🔥",
      message30: "¡Increíble! ¡Estás en racha!",
      messageLegend: "¡LEYENDA! ¡Racha excepcional! 🏆",
      shareText: "🔥 ¡{{count}} días seguidos en Sclépios IA! Pon a prueba tus conocimientos médicos 👇",
      share: "Compartir"
    },
    dailyGoal: {
      title: "Objetivo del día",
      flashcards: "Repasar tarjetas",
      quiz: "Completar el quiz diario",
      chat: "Chatear con el asistente IA",
      completed: "{{count}}/{{total}} completados",
      goalReached: "🎉 ¡Objetivo alcanzado!"
    },
    trial: {
      label: "Prueba: ",
      daysRemaining: "{{count}}d restante",
      daysRemaining_plural: "{{count}}d restantes",
      actions: "{{used}}/{{total}} acciones",
      seePlans: "Ver planes"
    },
    referral: {
      title: "Invita a un colega",
      subtitle: "+7d Premium para ti, +3d para tu referido",
      godchildren: "{{count}} referido",
      godchildren_plural: "{{count}} referidos",
      nextMilestone: "Próximo hito:",
      shareLink: "Compartir enlace",
      shareText: "🩺 ¡Únete a Sclépios IA, el asistente médico inteligente! Usa mi código {{code}} para obtener 3 días Premium gratis 🎁",
      milestoneAmbassador: "Embajador",
      milestoneRecruiter: "Reclutador",
      milestoneLegend: "Leyenda",
      rewardAmbassador: "Insignia de Embajador",
      rewardRecruiter: "Insignia de Reclutador",
      rewardLegend: "1 mes Premium gratis"
    },
    explore: {
      title: "Explorar todas las funciones",
      learning: "Aprendizaje",
      clinicalTools: "Herramientas clínicas",
      community: "Comunidad",
      revisionSheets: "Fichas de revisión",
      study: "Estudio",
      courses: "Cursos",
      clinicalCases: "Casos clínicos",
      calculators: "Calculadoras",
      checklists: "Listas de verificación",
      medications: "Medicamentos",
      coding: "Codificación",
      guidelines: "Guías",
      forum: "Foro",
      scores: "Puntuaciones"
    },
    stats: {
      title: "Tus estadísticas",
      flashcards: "Tarjetas de estudio",
      sessions: "Sesiones",
      totalTime: "Tiempo total",
      accuracy: "Precisión",
      aiConversations: "Conversaciones IA",
      revisionSheets: "Fichas de revisión",
      qcmCompleted: "MCQ completados",
      communityPosts: "Publicaciones"
    },
    quickActions: {
      title: "Acciones rápidas",
      description: "Accede rápidamente a tus herramientas de aprendizaje favoritas",
      startStudy: "Comenzar estudio",
      createFlashcard: "Crear tarjetas",
      reviewCards: "Repasar tarjetas",
      newChat: "Nuevo chat",
      newChatDesc: "Chatea con IA médica para obtener respuestas a tus preguntas",
      flashcards: "Tarjetas de estudio",
      flashcardsDesc: "Crea y estudia con tarjetas de revisión inteligentes",
      revisionSheets: "Fichas de revisión",
      revisionSheetsDesc: "Ve tus fichas de revisión generadas por IA",
      study: "Estudiar",
      studyDesc: "Practica con MCQ adaptativos y casos clínicos",
      scores: "Puntuaciones",
      scoresDesc: "Calcula puntuaciones médicas e índices clínicos",
      community: "Comunidad",
      communityDesc: "Comparte y discute con la comunidad médica",
      calculator: "Calculadora",
      calculatorDesc: "Herramientas de cálculo médico y dosificaciones",
      checklists: "Listas de verificación",
      checklistsDesc: "Listas de verificación para procedimientos médicos",
      medications: "Medicamentos",
      medicationsDesc: "Base de datos de medicamentos e interacciones",
      coding: "Codificación",
      codingDesc: "Códigos CIE-10 y herramientas de codificación médica",
      rss: "Noticias RSS",
      rssDesc: "Sigue las últimas noticias médicas"
    },
    recentActivity: {
      title: "Actividad reciente",
      description: "Tu progreso y actividades recientes",
      noActivity: "Sin actividad reciente",
      active: "Activo",
      available: "Disponible",
      progress: "En progreso",
      participate: "Participar",
      new: "Nuevo",
      create: "Crear",
      conversations: "{{count}} conversación{{s}}",
      flashcards: "{{count}} tarjeta{{s}} de estudio",
      revisionSheets: "{{count}} ficha{{s}} de revisión",
      qcmCompleted: "{{count}} MCQ completado{{s}}",
      communityPosts: "{{count}} publicación{{s}}",
      firstChat: "Comienza tu primera conversación",
      firstFlashcards: "Crea tus primeras tarjetas",
      firstRevisionSheet: "Genera tu primera ficha"
    },
    badges: {
      title: "Insignias",
      noBadges: "Aún no has ganado insignias. ¡Sigue haciendo cuestionarios para desbloquear tus primeras insignias!",
      badgeUnlocked: "Insignia desbloqueada"
    },
    milestones: {
      title: 'Tus Próximos Objetivos',
      subtitle: 'Sigue progresando para desbloquear recompensas exclusivas',
      allCompleted: '¡Felicidades! Has alcanzado todos los objetivos disponibles',
      unlocked: 'Desbloqueado',
      progress: 'Progreso',
      streak7Title: 'Racha de 7 días',
      streak7Desc: 'Conéctate 7 días seguidos',
      streak7Reward: '100 XP + Insignia Dedicado',
      streak30Title: 'Racha de 30 días',
      streak30Desc: 'Un mes de disciplina diaria',
      streak30Reward: '500 XP + 1 semana Premium gratis',
      flashcards100Title: 'Maestro de Flashcards',
      flashcards100Desc: 'Crea 100 flashcards',
      flashcards100Reward: 'Insignia Flashcard Master',
      quiz50Title: 'Experto en Quiz',
      quiz50Desc: 'Completa 50 cuestionarios diarios',
      quiz50Reward: 'Insignia Quiz Champion + 300 XP',
      chat100Title: 'Conversador',
      chat100Desc: 'Ten 100 conversaciones con la IA',
      chat100Reward: 'Insignia AI Expert + 400 XP',
    }
  }
};
